var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},[_c('div',{staticClass:"Content"},[_c('CLogin')],1),_c('div',{staticClass:"Imagenes"},[_c('sliderVue',{staticStyle:{"height":"100vh","border":"none","margin":"0"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }